import { useGetMerchantAppProductsQuery } from "Api/Queries/Merchants/useGetMerchantAppProductsQuery";
import { useGetMerchantPricingsQuery } from "Api/Queries/Merchants/useGetMerchantPricingsQuery";
import type { ProductPricingsType } from "Components/Hunter/Merchants/types";

export const useMerchantAppProductsPricings = (merchantPublicID?: string) => {
  const {
    data: merchantAppProducts,
    isLoading: isMerchantAppProductsLoading,
    isError: isMerchantAppProductsError,
  } = useGetMerchantAppProductsQuery(merchantPublicID);

  const {
    data: allAvailablePricings,
    isLoading: isPricingsLoading,
    isError: isPricingsError,
  } = useGetMerchantPricingsQuery();

  if (isMerchantAppProductsLoading || isPricingsLoading) {
    return {
      isLoading: true,
      isError: false,
      groupedPricings: [],
      allGroupedPricings: [],
    };
  }

  if (
    isMerchantAppProductsError ||
    isPricingsError ||
    !allAvailablePricings ||
    !merchantAppProducts
  ) {
    return {
      isLoading: false,
      isError: true,
      groupedPricings: [],
      allGroupedPricings: [],
    };
  }

  const allGroupedPricings = allAvailablePricings.reduce(
    (
      acc,
      {
        code,
        merchantPricingID,
        productName,
        hunterLicenseDirectFee,
        totalFee,
        merchantPricingVariant,
        assignedCount,
      },
    ) => {
      const existingGroup = acc.find((group) => group.code === code);

      if (existingGroup) {
        existingGroup.variants.push({
          id: merchantPricingID,
          productName,
          hunterLicenseDirectFee,
          totalFee,
          merchantPricingVariant,
          assignedCount,
        });
      } else {
        acc.push({
          code: code ?? null,
          variants: [
            {
              id: merchantPricingID,
              productName,
              hunterLicenseDirectFee,
              totalFee,
              merchantPricingVariant,
              assignedCount,
            },
          ],
        });
      }

      return acc;
    },
    [] as ProductPricingsType,
  );

  const groupedPricings = allGroupedPricings.filter(({ code }) =>
    merchantAppProducts.some(({ productDto }) => productDto.code === code),
  );

  return {
    isLoading: false,
    isError: false,
    groupedPricings,
    allGroupedPricings,
  };
};
